import { useEffect } from "react";
import { useForm } from "react-hook-form";

import Modal, { ModalProps } from "../../layouts/Modal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { TextInput } from "../shared/Inputs/TextInput";
import PickAddress from "../shared/Addresses/PickAddress";
import { AccountAddressCreateEditFormFields } from "../../models/account/IAccountAddress";

interface AccountAddressDraftModalProps
  extends Omit<ModalProps, "children" | "width"> {
  address?: AccountAddressCreateEditFormFields;
  onSaved: (address: AccountAddressCreateEditFormFields) => void;
}

export function AccountAddressDraftModal({
  open,
  setOpen,
  address,
  onSaved,
}: AccountAddressDraftModalProps) {
  const { register, setValue, watch, handleSubmit, reset } =
    useForm<AccountAddressCreateEditFormFields>();

  useEffect(() => {
    reset(address ?? {});
  }, [address, open, reset]);

  const onSubmit = (data: AccountAddressCreateEditFormFields) => {
    onSaved(data);
    setOpen(false);
  };

  return (
    <Modal width="max-w-2xl" open={open} setOpen={setOpen}>
      <h2 className="text-xl font-semibold mb-6">{`${address ? "Edit" : "Add"} Address`}</h2>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid grid-cols-1 sm:grid-cols-2 gap-4"
      >
        <TextInput label="Name" register={register} registerName="name" cols="col-span-2" rounded />
        <PickAddress register={register} setValue={setValue} watch={watch} classes="col-span-2" rounded />
        <ButtonInput
          label="Save Address"
          isSubmit={true}
          classes="mt-6"
          onClick={undefined}
        />
      </form>
    </Modal>
  );
}

